export enum ConnectPlatform {
  RD_STATION = 18,
  ACTIVE_CAMPAIGN = 13,
  LEAD_LOVERS = 17,
  BLING = 31
}
